import { get, post } from '@/services/http';
import { EventBus } from '@/main';

interface EligibilityResponse {
  eligible: boolean;
  reason?: string;
  lastRequestedAt?: string;
  attemptsThisYear?: number;
}

interface RecordResponse {
  id: number;
  recorded: boolean;
}

class ReviewRequestService {
  private requestAttemptedThisSession: boolean = false;

  async checkEligibility(source?: string): Promise<EligibilityResponse> {
    const params: any = {};
    if (source) {
      params.source = source;
    }
    const response: any = await get('/reviews/eligibility', params);
    return response.data;
  }

  async recordRequest(
    responseCode: string,
    success: boolean,
    triggerEvent: string,
    metadata?: any
  ): Promise<RecordResponse> {
    const response: any = await post('/reviews/record', {
      responseCode,
      success,
      triggerEvent,
      metadata
    });
    return response.data;
  }

  /**
   * Attempt to request a review after a successful workflow.
   * Shows a dialog asking the merchant to leave a review on the Shopify App Store.
   */
  async attemptReviewRequest(
    storeId: number,
    triggerEvent: string,
    source?: string
  ): Promise<void> {
    if (this.requestAttemptedThisSession) {
      return;
    }

    const sessionKey = `review_request_checked_${storeId}`;
    if (sessionStorage.getItem(sessionKey)) {
      return;
    }

    try {
      const eligibility = await this.checkEligibility(source);

      if (!eligibility.eligible) {
        sessionStorage.setItem(sessionKey, 'true');
        return;
      }

      this.requestAttemptedThisSession = true;
      sessionStorage.setItem(sessionKey, 'true');

      // Wait for the success state to settle
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Show review request dialog
      EventBus.$emit('show-review-request-dialog', {
        storeId,
        triggerEvent
      });

    } catch (error: any) {
      console.error('[ReviewRequest] Error:', error);
    }
  }
}

export const reviewRequestService = new ReviewRequestService();
